import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	create: {
		defaultMessage: 'Create',
		id: 'atlassian-navigation.universal-create.create',
		description: 'Create text for the universal create button',
	},
	createIssue: {
		defaultMessage: 'Work item',
		id: 'atlassian-navigation.universal-create.create-button-aria-label',
		description: 'Create a new work item button aria-label text',
	},
});
